import axios from 'axios';

const LEAD_ROUTES_PATH = 'users/lead-routes';

export default {
  namespaced: true,
  state: {
    data: [],
    hasError: false,
    errorMsg: '',
    hasSuccess: false,
    isLoading: false,
  },
  mutations: {
    setData(state, data) {
      state.data = data;
    },
    setError(state, error) {
      state.hasError = true;
      state.errorMsg = error.error;
    },
    clearError(state) {
      state.hasError = false;
      state.errorMsg = '';
    },
    setSuccess(state, bool) {
      state.isLoading = false;
      state.hasError = false;
      state.errorMsg = '';
      state.hasSuccess = bool;
    },
    clearMessages(state) {
      state.isLoading = false;
      state.hasError = false;
      state.errorMsg = '';
      state.hasSuccess = false;
    },
    setIsLoading(state, bool) {
      state.isLoading = bool;
    },
  },
  actions: {
    async findLeadRoutes({ commit }) {
      try {
        commit('setIsLoading', true);
        const { data } = await axios.get(
          `${process.env.VUE_APP_ACCOUNTS_API}/${LEAD_ROUTES_PATH}?$limit=0`,
        );
        commit('setData', data.data);
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
    async saveLeadRoute({ commit }, payload) {
      try {
        commit('setIsLoading', true);
        delete payload.id;
        await axios.post(`${process.env.VUE_APP_ACCOUNTS_API}/${LEAD_ROUTES_PATH}`, payload);
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
    async updateLeadRoute({ commit }, payload) {
      try {
        commit('setIsLoading', true);
        await axios.patch(
          `${process.env.VUE_APP_ACCOUNTS_API}/${LEAD_ROUTES_PATH}/${payload.id}`,
          payload,
        );
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
    async deleteLeadRoute({ commit }, sourceAutopilotID) {
      try {
        commit('setIsLoading', true);
        await axios.delete(
          `${process.env.VUE_APP_ACCOUNTS_API}/${LEAD_ROUTES_PATH}/${sourceAutopilotID}`,
        );
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
  },
};
